import 'reflect-metadata';
import { User, UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

export class AuthService {
    private userManager: UserManager;

    constructor(
        authority: string,
        client_id: string,
        scope: string,
        silent_redirect_uri: string,
        redirect_uri: string
    ) {
        const settings: UserManagerSettings = {
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            authority: authority,
            client_id: client_id,
            response_type: 'code',
            scope: scope,
            redirect_uri: redirect_uri,
            post_logout_redirect_uri: window.location.origin,
            silent_redirect_uri: silent_redirect_uri,
            accessTokenExpiringNotificationTimeInSeconds: 10,
            automaticSilentRenew: true,
            filterProtocolClaims: true,
            staleStateAgeInSeconds: 60 * 60 * 24,
            response_mode: 'query',
            // loadUserInfo: true,
        };

        this.userManager = new UserManager(settings);
    }

    public async getUser(): Promise<User | null> {
        return await this.userManager.getUser();
    }

    public async signinRedirectCallback(): Promise<User> {
        await this.userManager.clearStaleState();
        const userPromise = await this.userManager.signinRedirectCallback();
        return userPromise;
    }

    public signinSilentCallback() {
        return this.userManager.signinSilentCallback();
    }

    public login(queryParams: Record<string, string | number | boolean> | undefined = {}): Promise<void> {
        return this.userManager.signinRedirect({
            extraQueryParams: queryParams,
            state: queryParams,
        });
    }

    public async logout(
        redirectUrl: string,
        queryParams: Record<string, string | number | boolean> | undefined = {}
    ): Promise<void> {
        return await this.userManager.signoutRedirect({
            post_logout_redirect_uri: redirectUrl,
            extraQueryParams: queryParams,
        });
    }

    public async getAccessToken(): Promise<string | undefined> {
        return (await this.getUser())?.access_token;
    }
}
